import { Event } from '../lib/types';

interface AddressCardProps {
  event: Event;
  onOpenMap: () => void;
}

export default function AddressCard({ event, onOpenMap }: AddressCardProps) {
  if (!event.event_address) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg p-4 shadow">
      <div className="flex items-center space-x-2 mb-4">
        <svg className="h-5 w-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
        <h3 className="text-lg font-semibold text-gray-900">
          {event.event_location_friendly || 'Location'}
        </h3>
      </div>
      <div className="flex items-start space-x-3">
        <div className="flex-1 min-w-0">
          <p className="text-gray-600 text-sm truncate">
            {event.event_address}
          </p>
          <button 
            onClick={onOpenMap}
            className="text-blue-600 text-sm font-medium hover:text-blue-700 transition-colors mt-2"
          >
            View Map and Directions
          </button>
        </div>
        <div className="flex-shrink-0">
          <div className="w-16 h-12 bg-gray-200 rounded-lg flex items-center justify-center overflow-hidden">
            <svg className="h-8 w-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-1.447-.894L15 4m0 13V4m-6 3l6-3" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}
